import PropTypes from 'prop-types';

const HouseNotVerifiedIcon = ({ color = '#0D0D0D', className = '' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M0.75 23.25V9.75672L12 0.952375L23.25 9.75672V23.25H0.75Z"
      stroke={color}
      strokeWidth="1.5"
    />
    <circle
      cx="16.5"
      cy="14.5"
      r="1.5"
      transform="rotate(-180 16.5 14.5)"
      fill={color}
    />
    <circle
      cx="12"
      cy="14.5"
      r="1.5"
      transform="rotate(-180 12 14.5)"
      fill={color}
    />
    <circle
      cx="7.5"
      cy="14.5"
      r="1.5"
      transform="rotate(-180 7.5 14.5)"
      fill={color}
    />
  </svg>
);

HouseNotVerifiedIcon.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string
};

export default HouseNotVerifiedIcon;
